import { useCallback, useMemo, useState } from 'react';
import { OPEN_INTEGRATION_EVENT_MODAL } from 'crm-events-data';
import { EnhancedTimelineIframe } from 'crm-events/integrations';
import { fromJS } from 'immutable';
import { jsx as _jsx } from "react/jsx-runtime";
export const useIntegrationModalActionHandler = () => {
  const [eventData, setEventData] = useState(null);
  const handleIntegrationModalAction = useCallback((actionType, data) => {
    if (actionType === OPEN_INTEGRATION_EVENT_MODAL) {
      setEventData(fromJS(data.eventData));
      return;
    }
  }, [setEventData]);
  const handleIntegrationModalClose = useCallback(() => {
    setEventData(null);
  }, [setEventData]);
  const integrationModal = useMemo(() => {
    if (!eventData) {
      return null;
    }
    return /*#__PURE__*/_jsx(EnhancedTimelineIframe, {
      closeIframeModal: handleIntegrationModalClose,
      eventData: eventData
    });
  }, [eventData, handleIntegrationModalClose]);
  return {
    handleIntegrationModalAction,
    integrationModal
  };
};